export default __webpack_public_path__ + "static/media/logo.91d7b79e.png";